import { useState, type FormEvent } from "react";

import type { ApiError } from "../api/types";

interface LoginPaneProps {
  onLogin: (devToken: string) => void;
  isLoggingIn: boolean;
  error: ApiError | null;
}

export function LoginPane({ onLogin, isLoggingIn, error }: LoginPaneProps) {
  const [devToken, setDevToken] = useState("");

  function handleSubmit(event: FormEvent<HTMLFormElement>): void {
    event.preventDefault();
    const trimmed = devToken.trim();
    if (trimmed) {
      onLogin(trimmed);
    }
  }

  return (
    <div className="flex h-full flex-col items-center justify-center gap-4 p-6">
      <div className="w-full max-w-xs">
        <h1 className="mb-1 text-lg font-semibold text-slate-900">
          File to Egnyte
        </h1>
        <p className="mb-4 text-sm text-slate-500">
          Sign in with a dev token to continue.
        </p>
        <form onSubmit={handleSubmit} className="flex flex-col gap-3">
          <div className="flex flex-col gap-1">
            <label
              htmlFor="dev-token"
              className="text-sm font-medium text-slate-700"
            >
              Dev token
            </label>
            <input
              id="dev-token"
              name="dev-token"
              type="password"
              autoComplete="off"
              value={devToken}
              onChange={(event) => setDevToken(event.target.value)}
              placeholder="dev-…"
              className="rounded-md border border-slate-300 px-3 py-2 text-sm shadow-sm focus:border-blue-500 focus:outline-none focus:ring-1 focus:ring-blue-500"
            />
          </div>
          <button
            type="submit"
            disabled={isLoggingIn || devToken.trim().length === 0}
            className="rounded-md bg-blue-700 px-3 py-2 text-sm font-medium text-white shadow-sm hover:bg-blue-800 disabled:cursor-not-allowed disabled:opacity-50"
          >
            {isLoggingIn ? "Signing in…" : "Sign in"}
          </button>
          {error && (
            <p role="alert" className="text-sm text-red-600">
              {error.message}
            </p>
          )}
        </form>
      </div>
    </div>
  );
}
